import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrandNameModalComponent} from './brand-name-modal.component';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { ButtonModule} from '@xref/xref-lib';

@NgModule({
  declarations: [BrandNameModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    ButtonModule
  ],
  exports: [BrandNameModalComponent]
})
export class BrandNameModalModule { }
